"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const each_1 = require("./pipe/each");
const function_1 = require("./pipe/function");
const match_1 = require("./pipe/match");
exports.pipeExpression = ({ ast, execObject }) => {
    const fromAst = ast.children.head[0];
    let fromValue = execObject.interpreter({ ast: fromAst, execObject });
    if (ast.children.tail) {
        fromValue = ast.children.tail.reduce((last, pipeAst) => {
            const pipeExpressionAst = pipeAst.children.rules[0].children;
            // console.log(pipeExpressionAst);
            // console.log(fromValue);
            if (pipeExpressionAst.toEach) {
                return each_1.execEach({ ast: pipeExpressionAst, execObject }, last);
            }
            else if (pipeExpressionAst.DotsIdentifier) {
                return function_1.execFunction({ ast: pipeExpressionAst, execObject }, last);
            }
            else if (pipeExpressionAst.toMatch) {
                return match_1.execMatch({ ast: pipeExpressionAst, execObject }, last);
            }
        }, fromValue);
    }
    return fromValue;
};
